import { render, staticRenderFns } from "./WheelInspectionManagementList.vue?vue&type=template&id=68fe2ed2&scoped=true"
import script from "./WheelInspectionManagementList.vue?vue&type=script&lang=js"
export * from "./WheelInspectionManagementList.vue?vue&type=script&lang=js"
import style0 from "./WheelInspectionManagementList.vue?vue&type=style&index=0&id=68fe2ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fe2ed2",
  null
  
)

export default component.exports